import { sgiConfig, uuid } from 'rt-sd-common';

Object.assign(sgiConfig, window.sgiSrvUrl);

// sgiConfig.popMessageMaxCount = 1;//popMessage方法弹出消息最大数量
sgiConfig.prmRelease = false;//参数工厂获取参数时是否优先发布版本
sgiConfig.keyPre_app = uuid(6);//项目每次加载生成一个独立标识
sgiConfig.keyPre_uuid = sgiConfig.keyPre_app + "-UUID-";//storage存放uuid的前缀
sgiConfig.keyPre_echo = sgiConfig.keyPre_app + "-ECHO-";//storage存放回显缓存的前缀
if (!sgiConfig.abb_project) sgiConfig.abb_project = "MDC";//项目缩写名称，用于cookie前缀标识等

//给类添加公共方法
window.sgiConfig = sgiConfig;


//客群配置
let custGroupConfig = custGroupConfig || {};
window.custGroupConfig = {
    ...custGroupConfig,
    valueTypePrm: "workbench_param_sc_0002"
}



// WEBPACK FOOTER //
// ./apps/conf/sgiConfig.js